var location_caller = '';

// Get user current location
function getCurrentLocation() {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
    } else {
        console.log('Geolocation is not supported by this browser.');
    }
}

// Callback function
function successCallback(position) {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;

    /*console.log('Latitude:', latitude);
    console.log('Longitude:', longitude);*/

    getLocationByLatLong(latitude, longitude, 'current-location');
}

// Error callback function
function errorCallback(error) {
    console.log('Error:', error.message);
}

/** Search by zip code */
const searchByZipCodeButton = document.getElementById('zip-Code');
if (searchByZipCodeButton) {
    searchByZipCodeButton.addEventListener('click', function() {
        searchByZipCode();
    });
}

function isValidZipCode(zip_code) {
    // Regexp to validate if the zip code is valid
    var zipCodePattern = /^\d{5}(?:[-\s]\d{4})?$/;

    // Check if zip code is valid
    if (zipCodePattern.test(zip_code)) {
        return true;
    } else {
        return false;
    }
}

// Import the 'mapbox-sdk' library
mapboxgl.accessToken = 'pk.eyJ1IjoidGJvb2RyYW0iLCJhIjoiY2tmNGJzbmdkMGJocjJ1bHM5OWQ2MDFuciJ9.-WQzts5NPhZTZ29CUKZzxg';
//------Added B) -------------------------//
if (document.location.pathname === "/locator-search-result/") {
    var map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/streets-v11',
        center: [-74.5, 40], // [lng, lat]
        zoom: 9
    });
    // Wait for the map to load
    map.on('load', function() {
        // Add markers to the map
        var markers = [
            { coordinates: [-74.5, 40], title: 'Marker 1' },
            { coordinates: [-73.9, 40.7], title: 'Marker 2' },
            { coordinates: [-74.2, 40.5], title: 'Marker 3' }
        ];

        markers.forEach(function(marker) {
            var el = document.createElement('div');
            el.textContent = '1';
            el.className = 'marker';

            new mapboxgl.Marker(el)
                .setLngLat(marker.coordinates)
                .setPopup(new mapboxgl.Popup().setHTML('<p class="marker-title">' + marker.title + '</p>' + '<p>Address 1</p><p>Address 1</p><a herf="tel:(000) 000-0000" class="btn ba-btn-default marker-btn">(000) 000-0000</a><a herf="#" class="btn ba-btn-dark marker-btn">View Location Details</a>'))
                .addTo(map);
        });
    });
}
// end //

// Function to get the latitude and longitude based on a zip code
function getCoordinatesFromZipCode(zipCode) {
    jQuery('.invalid-zip-code').css('display', 'none'); // Hide the error message

    fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${zipCode}.json?country=US&access_token=${mapboxgl.accessToken}`
    )
      .then(response => response.json())
      .then(data => {
        if (data && data.features && data.features.length > 0) {
          
            var coordinates = data.features[0].center;
            var latitude = coordinates[1];
            var longitude = coordinates[0];
            getLocationByLatLong(latitude, longitude, 'input');

        } else {
            jQuery('.invalid-zip-code').html('No Locations within 50 miles');
            jQuery('.invalid-zip-code').css('display', 'block');
        }
      })
      .catch(error => {
        console.log('Error fetching coordinates:', error);
      });
}

function searchByZipCode() {
    var zipCodeInput = document.querySelector('.zip-code-input');
    var zipCodeValue = zipCodeInput.value.trim();
    jQuery('.invalid-zip-code').css('display', 'none');
    
    
    if (zipCodeValue !== '' && isValidZipCode(zipCodeValue)) {
        location_caller = 'zip-code';
        jQuery('.invalid-zip-code').css('display', 'none');
        
        getCoordinatesFromZipCode(zipCodeValue);
    } else {
        jQuery('.invalid-zip-code').html('Invalid zip code');
        jQuery('.invalid-zip-code').css('display', 'block');
    }
}

function getLocationByLatLong(latitude, longitude, caller) { // We need to know who's calling it too
    

    /*console.log('Latitude:', latitude);
    console.log('Longitude:', longitude);
    alert('latitude = ' + latitude + ' \n' + 'Longitude = ' + longitude);*/

    if (location_caller != '') {
        caller = location_caller;
    }

    // AJAX Object
    var data = {
        action: 'get_location_by_zipcode',
        latitude: latitude,
        longitude: longitude
    };

    jQuery.post(
        ajax_object.ajax_url, 
        data,
        function(response) {
                var tracking = {
                    'event': 'location_search',
                    'eventCategory': 'Submit',
                    'search_query': response.location_name,
                    'eventAction': 'location_search',
                    'click_text': 'Find My Location',
                    'Description': 'Custom Event',
                    };
                dataLayer.push(tracking);
            if (response.data.found) {
                if (caller == 'automatic-geo-location') {
                    saveLocationData(response.data.location_id, response.data.location_name, response.data.permalink, response.data.phone);
                    showUsersNearestLocationOnTopBar();
                    setLocalizedPhoneNumber();
                } else {
                    document.location.href = response.data.permalink;
                }
            } else {
                if (caller == 'input') { // Used if on locations page
                    //jQuery('.invalid-zip-code').html('No Locations within 50 miles');
                    //jQuery('.invalid-zip-code').css('display', 'block');
                    jQuery("#base-model").modal("show");
                } else if (caller == 'top-bar') {
                    jQuery("#base-model").modal("show");
                } else if (caller == 'automatic-geo-location') {
                    //console.log('automatic geo location could not be triggered');
                    // Do nothing if the user couldn't be geo located
                } else { // If use my current location on locations page
                    //jQuery('.invalid-zip-code-current-location').html('No Locations within 50 miles');
                    //jQuery('.invalid-zip-code-current-location').css('display', 'block');
                    jQuery("#base-model").modal("show");
                }
            }
        }
    );
}

/**
 * Function used to save the location name and permalink using cookies
 * @param {string} name 
 * @param {string} permalink 
 */
function saveLocationData(location_id, name, permalink, phone) {
    const locationData = {
        location_id: location_id,
        name: name,
        permalink: permalink,
        phone: phone
    };
    setCookie('locationData', JSON.stringify(locationData), 30); // Save the data for 30 days
}

/**
 * Function used to retrieve the location data from cookies
 */
function getLocationData() {
    const storedData = getCookie('locationData');
    if (storedData) {
        return JSON.parse(storedData);
    }
    return null;
}

/**
 * Function to set a cookie
 * @param {string} name 
 * @param {string} value 
 * @param {number} days 
 */
function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

/**
 * Function to get a cookie
 * @param {string} name 
 * @returns {string|null}
 */
function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function showUsersNearestLocationOnTopBar() {
    const data = getLocationData();

    if (data) {

        const formatted_phone_number = formatPhoneNumber(data.phone);

        jQuery('.topbar-find-my-location').text(data.name);
        jQuery('.topbar-find-my-location').attr('href', data.permalink);

        jQuery('.header-tel').text(formatted_phone_number);
        jQuery('.header-tel').attr('href', 'tel: ' + data.phone);
        jQuery('.header-tel').attr('data-localized', 'true');
        jQuery('.header-tel').attr('data-location-name', data.name);

        jQuery('.topbar-find-my-location').removeClass('topbar-find-my-location');
    }
}

function setLocalizedPhoneNumber() {
    const data = getLocationData();

    if (data) {
        const formatted_phone_number = formatPhoneNumber(data.phone);
        // Desktop phone number
        jQuery('.background-image-cta-block__phone-number').text(formatted_phone_number);
        jQuery('.background-image-cta-block__phone-number').attr('href', 'tel: ' + data.phone);
        jQuery('.background-image-cta-block__phone-number').attr('data-localized', 'true');
        jQuery('.background-image-cta-block__phone-number').attr('data-location-name', data.name);

        // Mobile phone number
        jQuery('a.ba-phone-btn').text('Call ' + formatted_phone_number);
        jQuery('a.ba-phone-btn').attr('href', 'tel: ' + data.phone);
        jQuery('a.ba-phone-btn').attr('data-localized', 'true');
        jQuery('a.ba-phone-btn').attr('data-location-name', data.name);
    }
}

function showLocationPhoneNumber() {
    var formatted_phone_number = jQuery('.hero-location__ctas a').text(); // Get the phone number formatted number from the hero CTA
    var phone_number_link = jQuery('.hero-location__ctas a').attr('href'); // Get the phone number link from the hero CTA
    var location_name = jQuery('#location_name').text();
    
    // Header phone number
    jQuery('.header-tel').text(formatted_phone_number);
    jQuery('.header-tel').attr('href', phone_number_link);
    jQuery('.header-tel').attr('data-localized', 'true');
    jQuery('.header-tel').attr('data-location-name', location_name);

    // Desktop phone number
    jQuery('.location-page-upper-footer .loc-phone').text(formatted_phone_number);
    jQuery('.location-page-upper-footer .loc-phone').attr('href', phone_number_link);
    jQuery('.location-page-upper-footer .loc-phone').attr('data-localized', 'true');
    jQuery('.location-page-upper-footer .loc-phone').attr('data-location-name', location_name);

    // Hero phone number
    jQuery('.hero-location .banner-tel').attr('data-localized', 'true');
    jQuery('.hero-location .banner-tel').attr('data-location-name', location_name);

    // Mobile phone number
    jQuery('a.ba-phone-btn').text('Call ' + formatted_phone_number);
    jQuery('a.ba-phone-btn').attr('href', phone_number_link);
    jQuery('a.ba-phone-btn').attr('data-localized', 'true');
    jQuery('a.ba-phone-btn').attr('data-location-name', location_name);
}

function formatPhoneNumber(phoneNumber) {
    // Remove all non-digit characters
    let cleaned = ('' + phoneNumber).replace(/\D/g, '');

    // Format the phone number
    let formatted = '(' + cleaned.substring(1, 4) + ') ' + 
                    cleaned.substring(4, 7) + '-' + 
                    cleaned.substring(7);

    return formatted;
}

jQuery(document).ready(function() {
    // Check if we already have user's location data on page load
    const data = getLocationData();
    
    if (ajax_object.site == 'tws' && jQuery('body').hasClass('single-location')) { // If it's TWS and we're on a single location, show the location phone
        showLocationPhoneNumber();
    } else if (data) {
        showUsersNearestLocationOnTopBar();
        setLocalizedPhoneNumber();
    } else if (ajax_object.site != 'tws') { // If we don't, try to get it from browsers location
        location_caller = 'automatic-geo-location';
        getCurrentLocation();
    }

    /** Submit the form on ENTER key press **/
    jQuery('.zip-code-input').keydown(function(event) {
        if (event.keyCode === 13) { 
            event.preventDefault(); 
        
            searchByZipCode();
        }
    });

    // Event click for "Use my current location"
    jQuery('#get-location').on('click', function() {
        location_caller = 'get-location';
        getCurrentLocation();
    });


    // Event click for "Find my location" on top bar
    jQuery('.topbar-find-my-location').on('click', function() {
        location_caller = 'top-bar';
        getCurrentLocation();
    });

    /*jQuery('.btn-geo-locate-me').on('click', function() {
        getLocationByLatLong(jQuery('.field_lat').val(), jQuery('.field_long').val(), 'automatic-geo-location');
    });*/

    // Check if there's a carousel
    if (jQuery('.carousel').length > 0) {
        jQuery('.carousel').slick({
            infinite: false,
            slidesToShow: 7,
            slidesToScroll: 7,
            variableWidth: true,
            responsive: [
                {
                  breakpoint: 767,
                  settings: {
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true
                  }
                }
            ],
            swipe: true,
            prevArrow: '<img src="/wp-content/themes/understrap-child/img/prev.svg" class="slick-prev" />',
            nextArrow: '<img src="/wp-content/themes/understrap-child/img/next.svg" class="slick-next" />',
            autoplay: true,
            autoplaySpeed: 3000,
            onInit: function(slick) {
                // Disable prev button on initialization if at the beginning
                jQuery('.slick-prev').toggleClass('slick-disabled', slick.currentSlide === 0);
            },
            onAfterChange: function(slick, currentSlide) {
                // Disable prev button when at the beginning
                jQuery('.slick-prev').toggleClass('slick-disabled', currentSlide === 0);
                
                // Disable next button when at the end
                jQuery('.slick-next').toggleClass('slick-disabled', currentSlide === slick.slideCount - slick.options.slidesToShow);
            }
        });
    }

    if (jQuery('.wh-gallery').length > 0) {
        jQuery('.wh-gallery').slick({
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            variableWidth: true,
            responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false
                  }
                }
            ],
            swipe: true,
            prevArrow: '<img src="/wp-content/themes/understrap-child/img/prev.svg" class="slick-prev" />',
            nextArrow: '<img src="/wp-content/themes/understrap-child/img/next.svg" class="slick-next" />',
            autoplay: true,
            autoplaySpeed: 3000,
            onInit: function(slick) {
                // Disable prev button on initialization if at the beginning
                jQuery('.slick-prev').toggleClass('slick-disabled', slick.currentSlide === 0);
            },
            onAfterChange: function(slick, currentSlide) {
                // Disable prev button when at the beginning
                jQuery('.slick-prev').toggleClass('slick-disabled', currentSlide === 0);
                
                // Disable next button when at the end
                jQuery('.slick-next').toggleClass('slick-disabled', currentSlide === slick.slideCount - slick.options.slidesToShow);
            }
        });
    }

    // Hero read more - smooth scroll to 
    if (jQuery(".read-more-reviews").length > 0) {
        jQuery(".read-more-reviews").click(function(event) {
            event.preventDefault();
            var target = jQuery("#location-reviews");
            if (jQuery(window).width() > 767) {
                var mainNavHeight = jQuery("#wrapper-navbar").height();
                jQuery("html, body").animate({ scrollTop: target.offset().top - mainNavHeight }, 1000);
            } else {
                jQuery("html, body").animate({ scrollTop: target.offset().top }, 1000);
            }
        });

        // If there's a read more reviews link
        if (jQuery(".expand-reviews").length) {
            jQuery(".expand-reviews").click(function(){
                jQuery(".card-review:nth-child(n+4)").css('display', 'flex');
                jQuery(this).css('display', 'none');
            });
        }
    }

    jQuery('.state-name').on('click', function() {
        if (jQuery(window).width() <= 480) {
            jQuery('.state-locations[data-state="' + jQuery(this).attr('id') + '"]').slideToggle();
        }
    });

    // Check if there's a hash on the URL, if there is, smoothly scroll to the section
    if (window.location.hash) {
        //setTimeout(function() {

            // Check if there's a hash
            var hash = window.location.hash.substring(1);

            // Check if there's an ID with that hash
            if (jQuery('#' + hash).length) {

                // Calculate position of the section
                //var offset = jQuery(window).width() > 767.98 ? 104 : 0;
                //var targetOffset = jQuery('#' + hash).offset().top - offset;
                var targetOffset = jQuery('#' + hash).offset().top;

                // Check if the resolution is greater than 768px before calculating the height of the main nav
                if (window.innerWidth > 768) {
                    // Get the height of the sticky header and add it to the position
                    var stickyHeaderHeight = jQuery('#main-nav').outerHeight();
                    targetOffset -= stickyHeaderHeight;
                }

                // Animate a scroll to that position
                jQuery('html, body').animate({
                    scrollTop: targetOffset
                }, 1000);
            }
        //}, 1000); 
    }
});